import { useContext, useMemo } from 'react'

import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../../contextAPI'

export const useRequestAProposal = () => {
  const { data, setQuizScreen, recordResponse } = useContext(QuizQuestionContext)

  const handleNext = () => {
    setQuizScreen(SCREEN_QUIZ_QUESTION.BUDGET)
  }

  const handleBack = () => {
    setQuizScreen(SCREEN_QUIZ_QUESTION.WEDDING_DATE)
  }

  const nextDisabled = useMemo(() => {
    return false
  }, [])

  return {
    data,
    nextDisabled,
    handleBack,
    handleNext,
    recordResponse,
  }
}
